<template lang="pug">
.bg-grey.w-full.p-40
  .max-w-718
    BriqPanel
      template(name="header")
        .flex.justify-between.align-start
          h2.h2.mb-S Mail
          BriqButton(
            small
            @click="$bus.$emit('sendMailBtnClicked')"
            variant="secondary"
            :disabled="disableSendMail"
            data-test-id="booking-send-mail-button"
            ) Send mail
      template
        BriqDataTable(:data="tableData" @click="openEmail" :initialSort="initialSort" data-test-id="booking-mail-table")
</template>

<script>
import { mapGetters } from 'vuex'
import BriqDataTable from '@v/components/BriqDataTable.vue'
import { fromUtc } from '@/helpers/dateTimeFormatter.js'
import Permission from '@v/models/UserPermissionEnum.js'

export default {
  name: 'MailsTab',
  components: { BriqDataTable },
  data() {
    return {
      initialSort: { sort: 'desc', sortField: 'DatetimeUTC' },
    }
  },
  computed: {
    ...mapGetters('bookingDetails', ['mails', 'bookingKey', 'booking']),
    ...mapGetters('briqState', ['userHasPermission']),
    disableSendMail() {
      return !this.userHasPermission(Permission.API_Admin_Booking_Mail_Send)
    },
    tableData() {
      return {
        items: this.mails.map(m => ({
          ...m,
          Datetime: fromUtc()(this.$locale)(this.$timezone)(m.DatetimeUTC),
        })),
        headers: [
          {
            field: 'Datetime',
            label: 'Date',
            sortField: 'DatetimeUTC',
          },
          { field: 'To', label: 'Receiver' },
          { field: 'Subject', label: 'Subject' },
          { field: 'Status', label: 'Status' },
          { field: 'CC', label: 'CC' },
          { field: 'BCC', label: 'BCC' },
          { field: 'From', label: 'From' },
        ],
      }
    },
  },
  methods: {
    openEmail({ item }) {
      this.$router.push({
        name: 'ViewBookingMail',
        params: { bookingKey: this.bookingKey, mailKey: item.Key },
      })
    },
  },
  beforeMount() {
    this.$setDocumentTitle(`Booking ${this.booking.Number} mails`)
  },
}
</script>
